import { render, staticRenderFns } from "./FeedbackPage.vue?vue&type=template&id=f6b8e3ae&scoped=true"
import script from "./FeedbackPage.vue?vue&type=script&lang=js"
export * from "./FeedbackPage.vue?vue&type=script&lang=js"
import style0 from "./FeedbackPage.vue?vue&type=style&index=0&id=f6b8e3ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b8e3ae",
  null
  
)

export default component.exports